export default {
    setUser(state, data) {
        localStorage.setItem('user', JSON.stringify(data));
        state.user = data;
    },
    setCompany(state, data) {
        localStorage.setItem('company', JSON.stringify(data));
        state.company = data;
    },
    setToken(state, token) {
        localStorage.setItem('token', JSON.stringify(token));
        state.token = token;
    },
    setRole(state, role) {
        localStorage.setItem('role', JSON.stringify(role));
        state.role = role;
    },
    setPermissions(state, permissions) {
        localStorage.setItem('permissions', JSON.stringify(permissions));
        state.permissions = permissions;
    },
};
